import { useLastPathSegment } from 'shared/hooks'
import { useAddNumberFromAppContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/AddNumberFromApp/context/useAddNumberFromAppContext'

export const useProgressInfoTitle = () => {
  const { getProgressInfoTitle } = useAddNumberFromAppContext()

  return getProgressInfoTitle(useLastPathSegment())
}
